import { defineStore } from "pinia"
import type { View } from "~/models/View"
import ProductCard from "~/components/CardProduct.vue"
import ProductItem from "~/components/ProductItem.vue"

/**
 * Welcome views.
 */
const views: View[] = [
    {
        name: "grid",
        classes: "tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 xl:tw-grid-cols-5",
        icon: "grid_view",
    },
    // ,{
    //     name: 'list',
    //     classes: 'tw-grid-cols-1 xl:tw-grid-cols-2',
    //     icon: 'list',
    //     component: ProductItem
    // }
]

/**
 * Welcome page store.
 *
 * @author Abel David.
 */
export const useShopStore = defineStore("welcome", {
    state: () => ({
        views: views,
        view: views[0],
    }),
    getters: {
        getComponent: (state) => {
            return state.view.name == "grid" ? ProductCard : ProductItem
        },
    },
})
